// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  // production: false,
  // API: 'http://192.168.1.15:3000',
  // apiEndpoint: 'http://192.168.1.15:3000'

  // API: 'https://admin.hazardeye.com.au/api',
  // apiEndpoint: 'https://admin.hazardeye.com.au/api',

  // HCS server
  publicKey:'pk_live_51LczneLozjlJw4YsVu5bQ10FUNsEqYMpCYN0uWPoaD3iBmh1FaURtA2CGEJbJxuU8I2V7JPd2udlngORazCqDXJ9003FKSE6nc',
  API: 'https://hazardeye.hcshub.in/hazardeye-api',
  apiEndpoint: 'https://hazardeye.hcshub.in/hazardeye-api',
  production: true,

   //25-09-2025//Production
  // production: true,
  // API: 'https://admin.hazardeye.com.au/api',
  // apiEndpoint: 'https://admin.hazardeye.com.au/api',
  // publicKey: 'pk_live_51LczneLozjlJw4YsVu5bQ10FUNsEqYMpCYN0uWPoaD3iBmh1FaURtA2CGEJbJxuU8I2V7JPd2udlngORazCqDXJ9003FKSE6nc'


  //25-09-2025//Localhost
  // production: false,
  // API: 'http://localhost:4600',
  // apiEndpoint: 'http://localhost:4600',
  // publicKey: 'pk_test_51JnLiRBZXyHvVMo3ac1Ityf8TsBA0KyrVJX9I2OUKgt8fURodEy43XUFy2CnO23mX2t3p3R7PvER0GX9sCh0EBtZ00WtsUHU83'

 
};
